import { render, staticRenderFns } from "./OptedCard.vue?vue&type=template&id=dc2d5e04&scoped=true"
import script from "./OptedCard.vue?vue&type=script&lang=js"
export * from "./OptedCard.vue?vue&type=script&lang=js"
import style0 from "./OptedCard.vue?vue&type=style&index=0&id=dc2d5e04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2d5e04",
  null
  
)

export default component.exports